module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-65e4d5797917cc7ef8219cc9bf5100f0.png";